import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { SearchButton } from './SearchButton';
import Authorization, { CheckAuthorization } from "./Base/Authorization";
import { BlankCard } from './Base/Common/CommonUIComponents';
import { SubscribeToCard } from './SubscribeToCard';
import { getAPI } from './Base/API';
import GoogleAnalytics from '../Utils/GoogleAnalytics';
import ErrorBoundary from '../Utils/ErrorBoundary';
import { BrowserVersionNotSupported, isBrowserVersionSupported } from './BrowserVersion';

export class Layout extends Component {
    static displayName = Layout.name;

    constructor(props) {
        super(props);

        const pageStates = [
            0,  //Pending
            1,  //Active
            2   //Inactive
        ];

        this.state = {
            block: true,
            pageStates: pageStates,
            pageStatus: pageStates[0] //starts pending
        };
    }

    componentDidMount() {
        this.refreshUserData();

        this.setState({ isBrowserVersionSupported: isBrowserVersionSupported() });
    }

    refreshUserData = () => {
       /* const data = {
    "id": 10005,
    "defaultProperty": "ea5d4aae-82a1-46e9-a9cb-7acfb4e6ef1e",
    "propertyName": "Casa areias",
    "uid": "e96bea7f-0109-40ad-89d3-0c0161d3ac6e",
    "operationMode": "PmsFull",
    "licenseLevel": "Connector",
    "modules": null,
    "hotelCurrency": "EUR",
    "userAllowedProperties": [
        {
            "id": 17441,
            "property": "497ccfdc-9761-4c45-98d8-126ff0501296",
            "propertyName": "Avenida de Fátima"
        }
    ],
    "channel": [
        "AVAILPRO",
        "QUOTELIER",
        "SABRE"
    ],
    "defaultPropertyActive": true,
    "pmsType": "None",
    "rmsType": "None",
    "hotelTimezone": "Atlantic/Madeira",
    "reservationDelivery": "None",
    "chainName": null,
    "sendRoomRate": false
}*/
       getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                global.channelList = data.channel;
                global.userAllowedProperties = data.userAllowedProperties;
                global.defaultProperty = data.defaultProperty;
                global.propertyName = data.propertyName;

                if (CheckAuthorization("CardClient")) {
                    this.getHotelData(data.defaultProperty);
                }
            }
            else {
                this.setState({ error: errorMessage, block: false });
            }
        }, '/api/User/v1/User');
    }

    getHotelData = (defaultProperty) => {
        const { pageStates } = this.state;

        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];
            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: "danger" });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data && data.response) {
                global.license = data.response[0].license;
                global.modules = data.response[0].modules;
                global.active = data.response[0].active;
                global.codeGenerationType = data.response[0].codeGenerationType;
                global.shortId = data.response[0].modules.some(el => el === "ShortId");
                global.hotelCurrency = data.response[0].defaultCurrency || 'EUR';
                global.registerSalesInPms = data.response[0].hotelConfig?.registerSalesInPms;
                global.hotelGroupId = data.response[0].hotelGroupId;
                global.defaultCultureCode = data.response[0].defaultCultureCode;
            }
            this.setState({ block: false, error: errorMessage, pageStatus: global.active ? pageStates[1] : pageStates[2] });
        }, `/api/Voucher/Hotel/v1/Hotel/${defaultProperty}`);
    }

    render() {
        const { block, error, pageStatus } = this.state;

        return (
            this.state.isBrowserVersionSupported ?
                <ErrorBoundary>
                    <div className="bg-light">
                        <GoogleAnalytics />

                        <Authorization
                            perform="CardClient"
                            yes={() => (
                                <>
                                    {pageStatus === 0 ?
                                        <BlankCard block={block} error={error} />
                                        :
                                        pageStatus === 1 ?
                                            <>
                                                <NavMenu />
                                                <Container className="bg-light ">
                                                    {this.props.children}
                                                    <SearchButton />
                                                </Container>
                                            </>
                                            :
                                            <SubscribeToCard />
                                    }
                                </>
                            )}
                            no={() => (
                                <SubscribeToCard />
                            )} 
                        />

                    </div>

                </ErrorBoundary>
                :
                <BrowserVersionNotSupported />
        );
    }
}